import React from "react";

export function TableLikeText({title, value, titleColor = "text-body-secondary", className = ""}) {
    return <div className={`d-flex gap-2 ${className}`}>
        <div className={titleColor}>{title}:</div>
        <div>{value}</div>
    </div>
}